import { Flex } from "rebass";

const OrderStatusBadge = ({ count, label, color, onClick, style }) => (
  <Flex
    minHeight={"25px"}
    p={1}
    backgroundColor={[null, null, color]}
    color={[color, color, "#fff"]}
    fontWeight={[null, 700]}
    sx={{
      border: `2px solid ${color}`,
      borderRadius: "3px",
    }}
    pb={0}
    pt={0}
    alignItems="center"
    fontSize={[".8em", "1em"]}
    onClick={onClick}
    style={style}
  >
    {count} {label}
  </Flex>
);

export default OrderStatusBadge;
